<div class="success-state-wrapper flex-vertical-center full-height ion-padding-horizontal">
    <div class="success-state-icon-wrapper">
        <lib-svg-icon iconName="checkmark-thin" [size]="45" />
    </div>
    <h1 class="success-state-title" *ngIf="title">{{ title }}</h1>
    <ng-content></ng-content>
</div>
